module.exports = "<div ng-transclude></div><label><input type=\"checkbox\" ng-model=\"enabled\"> {{:: \"Разрешить конфигурацию по-умолчанию\" | gettext}}</label><sc-speech-recognition-config ng-if=\"enabled\" config=\"config\" errors=\"errorMessage\" hide-default hide-force></sc-speech-recognition-config>"


//////////////////
// WEBPACK FOOTER
// ./src/speech/speech-recognition-settings.html
// module id = 338
// module chunks = 0